import { render, staticRenderFns } from "./AttachedNewProofOfTaxSituation.vue?vue&type=template&id=5f5894fa&scoped=true&"
import script from "./AttachedNewProofOfTaxSituation.vue?vue&type=script&lang=ts&"
export * from "./AttachedNewProofOfTaxSituation.vue?vue&type=script&lang=ts&"
import style0 from "./AttachedNewProofOfTaxSituation.vue?vue&type=style&index=0&id=5f5894fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5894fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
